(function($) {
    $.OSD = function(options) {
        this._component_name = "osd";
        // デフォルトをここで決定
        this._options = options || {};

        this._events = {
            ready: "ready"
        }; 

     
        // this._prefetch_content = new $.PrefetchContent(this._options.prefetch_content || []);
        this._overlay_options = options.overlay || {};
        if (typeof(this._overlay_options.overlays) !== 'undefined') {
            this._overlay_enabled = true; 
        }
        this._tileSources = options.tile_sources || null;
        this._dual = options.dual || false;
        this._dual_slider = options.dual_slider || false;
        this._two_tiles = Array.isArray(this._tileSources) && this._tileSources.length == 2; 
        // this._tracker_enabled = options.tracker || false;
        // this._tracker_options = options.tracker_options || {};
     
        this.viewers = [];
    
        this._containers_selectors = options.containers || ['#container'];
        this._containers = [];
        for (var i = 0; i < this._containers_selectors.length; i++) {
            var container = this._containers_selectors[i];
            if (typeof(container) === 'string') {
                container = document.querySelector(container);
            }
    
            if (container) {
                this._containers.push(container);
            } 
        } 

        this._osd_options = this._options.osd_options || {};
    
        // this.initialized_event = new CustomEvent('abdo_osd_initialized', 
        // { 
        //     detail: {
        //         abdo_osd: this,
        //         options: this._options
        //     }
        // });
    
        // 回転バーの無有効
        if (typeof(options.rotation_slider) === 'boolean') {
            this._rotation_slider = options.rotation_slider;
        }
        else {
            this._rotation_slider = false;
        }
    
        // 多言語の無有効、デフォルト：true
        if (typeof(options.multilanguage) === 'boolean') {
            this._multilanguage = options.multilanguage;
        }
        else {
            this._multilanguage = true;
        }
        this._multilanguage_options = options.multilanguage_options || {}; 
    
        // if (this._element == null) {
        //     return;
        // }
        this._on(this._events.subcomponents_ready, this._after_subcomponents_callback.bind(this));
        this._init_osd();

        this._ring_element = document.querySelector("#abdo-ring");
        if (!this._ring_element) {
            this._ring_element = document.createElement("div");
            this._ring_element.classList.add("abdo-waiting");
            this._ring_element.innerHTML = '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';
            document.body.appendChild(this._ring_element);
        }
    };
    
    $.Component.create($.OSD, {
        _show_ring: function() {
            if (this._ring_element) {
                this._ring_element.style.display = "block";
            }
        },
        _hide_ring: function() {
            if (this._ring_element) {
                this._ring_element.style.display = "";
            }
        },
        _after_subcomponents_callback: function() { 

            // if (this._tracker_enabled) {
            //     this._init_tracker();
            // }
            
            // if (this._overlay_enabled) { 
            //     this._init_overlay();
            // }

            if (this._rotation_slider && typeof(jQuery) !== 'undefined') {
                var self = this;
                // 回転sliderの初期化 
                var rotation_slider = document.createElement('div');
                rotation_slider.classList.add('rotation-slider');
                document.body.appendChild(rotation_slider);

                jQuery(rotation_slider).slider({
                    orientation: 'vertical',
                    min: -180,
                    max: 180,
                    slide: function(event, ui) {
                        for (var v_index = 0; v_index < self.viewers.length; v_index++) {
                            self.viewers[v_index].viewport.setRotation(ui.value);
                        }
                    }
                }); 
            }
        },

        init: function() {
            if (this._multilanguage) { 
                this.i18n = new $.I18n(this._multilanguage_options);
            }

            // this._prefetch_content.on('ready', this._after_prefetch_callback.bind(this));
            // this._prefetch_content.start();
        },

        _view_canvas_img: function() {
            if (this.viewers.length > 0 ) {
                var canvas_element = this.viewers[0].canvas.querySelector("canvas");
                var dataURL = canvas_element.toDataURL("image/png");
                var new_tab = window.open('about:blank','image from canvas');
                new_tab.document.write("<img src='" + dataURL + "' />");
            }
        },

        _view_canvas: function(canvas_element) { 
            var dataURL = canvas_element.toDataURL("image/png");
            var new_tab = window.open('about:blank','image from canvas');
            new_tab.document.write("<img src='" + dataURL + "' />"); 
        },

        _init_osd: function() {
            // キャンバスにかけるように
			OpenSeadragon.pixelDensityRatio = 1.0;

			OpenSeadragon.setString("Tooltips.Home", "最初の状態に戻す");
			OpenSeadragon.setString("Tooltips.ZoomOut", "縮小");
			OpenSeadragon.setString("Tooltips.ZoomIn", "拡大");
			OpenSeadragon.setString("Tooltips.FullPage", "画面いっぱいに広げる");
			OpenSeadragon.setString("Tooltips.NextPage", "次のページに進む");
			OpenSeadragon.setString("Tooltips.PreviousPage", "前のページに戻る");
			OpenSeadragon.setString("Tooltips.RotateLeft", "左に回転");
			OpenSeadragon.setString("Tooltips.RotateRight", "右に回転"); 

            var options = {
				prefixUrl: "openseadragon-2.4.2/images/",
				showNavigator: true,
				navigatorMaintainSizeRatio: true,
				maxZoomPixelRatio: 2.0,
				minZoomImageRatio: 0.5,
				sequenceMode: false,
				showReferenceStrip: false,
				preserveViewport: true,
				preserveImageSizeOnResize: true,
				defaultZoomLevel: 0.7,
				blendTime: 0.1,
				immediateRender: false,
				minScrollDeltaTime: 10,
				animationTime: 0.1,
				showZoomControl: true,
				showHomeControl: true,
				showFullPageControl: false,
				showRotationControl: false,
                navPrevNextWrap: false,
                
                // same as google maps
                gestureSettingsMouse: {
                    clickToZoom: false,
                    dblClickToZoom: true
                },
            };
            
            // パラメータに渡したOpenSeadragonの設定を書き込む
            for(var prop in this._osd_options) {
                if (this._osd_options.hasOwnProperty(prop)) {
                    options[prop] = this._osd_options[prop];
                }
            }
  
             
            var self = this;
            var cloned_options, viewer;
            if (this._two_tiles) { 
                if (this._dual_slider && this._containers.length == 1) {
                    // containerとviewerはそれぞれ一つが必要です 
                    cloned_options = ABDOUtil.clone(options);
                    cloned_options.id = this._containers[0].id;
                    // console.dir(cloned_options);
                    if (this._overlay_enabled) {
                        cloned_options.overlays = this._overlay_options.overlays;
                    }
                    viewer = OpenSeadragon(cloned_options);
                    this.viewers.push(viewer);
    
                    this.abdo_dual = new $.DualMap({
                        containers: this._containers,
                        viewers: this.viewers,
                        tile_source_left: this._tileSources[0],
                        tile_source_right: this._tileSources[1],
                    });
    
                    this.abdo_dual.on('loaded', function() {
                        self._osd_ready.call(self);
                    });
                }
                // container二つが必要
                else if (this._dual && this._containers.length == 2) {

                    // OSDの初期化
                    for (var i = 0; i < this._containers.length; i++) {
                        cloned_options = ABDOUtil.clone(options); // Deep copy
                        cloned_options.id = this._containers[i].id;
                        if (this._overlay_enabled) {
                            cloned_options.overlays = this._overlay_options.overlays;
                        }
                        viewer = OpenSeadragon(cloned_options);
                        this.viewers.push(viewer);  
                    }
    
                    this.abdo_dual = new $.DualMap({
                        containers: this._containers,
                        viewers: this.viewers,
                        tile_source_left: this._tileSources[0],
                        tile_source_right: this._tileSources[1],
                    });
    
                    this.abdo_dual.on('loaded', function() {
                        self._osd_ready.call(self);
                    });
                }
            }
            else {
                options.id = this._containers[0].id;
                viewer = OpenSeadragon(options); 
                this.viewers.push(viewer); 
                
                viewer.addTiledImage( {
                    tileSource: this._tileSources[0],
                    success: function( event ) {
                        self._osd_ready.call(self);
                    } 
                });
            } 

            // TODO add for dual view without slider 
        },

        _init_tracker: function() {
            this._tracker_options.viewers = this.viewers;
            this.tracker = new $.Tracker(this._tracker_options);
            this.tracker.init();
        },


        _init_overlay: function() {
            this._overlay_options.viewers = this.viewers;
            if (typeof(this.tracker) !== 'undefined') {
                this._overlay_options.tracker = this.tracker;
            }
            this.overlay = new $.Overlay(this._overlay_options);
        },

        _osd_ready: function() {
            for (var v_index = 0; v_index < this.viewers.length; v_index++) {
                this.viewers[v_index].viewport.goHome(); 
            }

            $.Component.call(this, $.OSD);
            // document.dispatchEvent(this.initialized_event);
            this._emit(this._events.ready);
        },

        on: function(event, fun) {
            this._on(event, fun);
        },
    });
 
})(ABDOMap);